// Luxembourg cities and postal codes
export const luxembourgCities = [
  { city: "Luxembourg-Ville", postalCode: "1111" },
  { city: "Luxembourg-Gare", postalCode: "1616" },
  { city: "Luxembourg-Kirchberg", postalCode: "1359" },
  { city: "Luxembourg-Limpertsberg", postalCode: "1940" },
  { city: "Luxembourg-Belair", postalCode: "1225" },
  { city: "Luxembourg-Bonnevoie", postalCode: "1260" },
  { city: "Luxembourg-Hollerich", postalCode: "1741" },
  { city: "Luxembourg-Merl", postalCode: "2145" },
  { city: "Luxembourg-Gasperich", postalCode: "1617" },
  { city: "Luxembourg-Clausen", postalCode: "1342" },
  { city: "Esch-sur-Alzette", postalCode: "4000" },
  { city: "Dudelange", postalCode: "3400" },
  { city: "Differdange", postalCode: "4500" },
  { city: "Schifflange", postalCode: "3800" },
  { city: "Bettembourg", postalCode: "3238" },
  { city: "Pétange", postalCode: "4700" },
  { city: "Ettelbruck", postalCode: "9000" },
  { city: "Diekirch", postalCode: "9200" },
  { city: "Strassen", postalCode: "8008" },
  { city: "Bertrange", postalCode: "8017" },
  { city: "Mamer", postalCode: "8210" },
  { city: "Hesperange", postalCode: "5765" },
  { city: "Sandweiler", postalCode: "5765" },
  { city: "Steinfort", postalCode: "8440" },
  { city: "Mersch", postalCode: "7501" },
  { city: "Junglinster", postalCode: "6101" },
  { city: "Grevenmacher", postalCode: "6701" },
  { city: "Remich", postalCode: "5501" },
  { city: "Echternach", postalCode: "6401" },
  { city: "Wiltz", postalCode: "9501" },
  { city: "Clervaux", postalCode: "9701" },
  { city: "Vianden", postalCode: "9401" },
  { city: "Mondorf-les-Bains", postalCode: "5601" },
  { city: "Rumelange", postalCode: "3700" },
  { city: "Kayl", postalCode: "3600" },
  { city: "Sanem", postalCode: "4400" },
  { city: "Leudelange", postalCode: "3361" },
  { city: "Roeser", postalCode: "3394" },
  { city: "Bascharage", postalCode: "4900" },
  { city: "Mondercange", postalCode: "3901" },
  { city: "Niederanven", postalCode: "6910" },
  { city: "Walferdange", postalCode: "7201" },
  { city: "Steinsel", postalCode: "7346" },
  { city: "Lorentzweiler", postalCode: "7361" },
  { city: "Kopstal", postalCode: "8065" },
  { city: "Kehlen", postalCode: "8280" },
  { city: "Capellen", postalCode: "8308" },
  { city: "Garnich", postalCode: "8353" },
  { city: "Hobscheid", postalCode: "8470" },
  { city: "Septfontaines", postalCode: "8363" },
  { city: "Redange", postalCode: "8501" },
  { city: "Rambrouch", postalCode: "8589" },
  { city: "Beckerich", postalCode: "8523" },
  { city: "Ell", postalCode: "8524" },
  { city: "Useldange", postalCode: "8706" },
  { city: "Saeul", postalCode: "8558" },
  { city: "Vichten", postalCode: "9166" },
  { city: "Bissen", postalCode: "7710" },
  { city: "Colmar-Berg", postalCode: "7730" },
  { city: "Schieren", postalCode: "9150" },
  { city: "Erpeldange", postalCode: "9122" },
  { city: "Feulen", postalCode: "9105" },
  { city: "Mertzig", postalCode: "9168" },
  { city: "Grosbous", postalCode: "9153" },
  { city: "Wahl", postalCode: "8820" },
  { city: "Préizerdaul", postalCode: "8821" },
  { city: "Bourscheid", postalCode: "9140" },
  { city: "Esch-sur-Sûre", postalCode: "9650" },
  { city: "Boulaide", postalCode: "9631" },
  { city: "Lac de la Haute-Sûre", postalCode: "9663" },
  { city: "Winseler", postalCode: "9696" },
  { city: "Goesdorf", postalCode: "9653" },
  { city: "Kiischpelt", postalCode: "9768" },
  { city: "Parc Hosingen", postalCode: "9807" },
  { city: "Weiswampach", postalCode: "9990" },
  { city: "Troisvierges", postalCode: "9907" },
  { city: "Wincrange", postalCode: "9780" },
  { city: "Munshausen", postalCode: "9766" },
  { city: "Heinerscheid", postalCode: "9753" },
  { city: "Consthum", postalCode: "9355" },
  { city: "Hoscheid", postalCode: "9351" },
  { city: "Putscheid", postalCode: "9462" },
  { city: "Tandel", postalCode: "9382" },
  { city: "Reisdorf", postalCode: "9390" },
  { city: "Berdorf", postalCode: "6550" },
  { city: "Beaufort", postalCode: "6310" },
  { city: "Consdorf", postalCode: "6211" },
  { city: "Waldbillig", postalCode: "6370" },
  { city: "Larochette", postalCode: "7610" },
  { city: "Nommern", postalCode: "7465" },
  { city: "Fischbach", postalCode: "7430" },
  { city: "Heffingen", postalCode: "7651" },
  { city: "Bech", postalCode: "6230" },
  { city: "Rosport-Mompach", postalCode: "6580" },
  { city: "Mertert", postalCode: "6680" },
  { city: "Wormeldange", postalCode: "5480" },
  { city: "Flaxweiler", postalCode: "6926" },
  { city: "Betzdorf", postalCode: "6940" },
  { city: "Biwer", postalCode: "6833" },
  { city: "Manternach", postalCode: "6850" },
  { city: "Mompach", postalCode: "6470" },
  { city: "Stadtbredimus", postalCode: "5765" },
  { city: "Lenningen", postalCode: "5765" },
  { city: "Waldbredimus", postalCode: "5765" },
  { city: "Dalheim", postalCode: "5765" },
  { city: "Frisange", postalCode: "5765" },
  { city: "Weiler-la-Tour", postalCode: "5765" },
  { city: "Contern", postalCode: "5310" },
  { city: "Schuttrange", postalCode: "5765" },
];

// Get formatted city string
export const formatCity = (city, postalCode) => `${city} (${postalCode})`;

// Search cities by query
export const searchCities = (query) => {
  if (!query || query.length < 2) return [];
  const lowerQuery = query.toLowerCase();
  return luxembourgCities
    .filter(c => 
      c.city.toLowerCase().includes(lowerQuery) || 
      c.postalCode.includes(query)
    )
    .slice(0, 8);
};
